import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../commonFields";

export const g2RatingBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "G2 Product rating",
  noWrap: true,
  inputs: [
    {
      name: "logo",
      type: "AprimoAssetSelector",
      helperText:
        "Select the logo to display next to the rating (e.g., G2 logo).",
      localized: false,
      defaultValue:
        "https://p1.aprimocdn.net/solarwinds/dd0ec7e6-a1a6-4e1a-8431-b399010b21d9/g2-logo_Original%20file.png?apr_source=APRIMO",
    },
    {
      name: "g2ProductId",
      type: "G2 connector",
      friendlyName: "G2 Product",
      helperText:
        "Select a product for the live G2 rating. Leave empty to always use the manual data below.",
      localized: false,
    },
    {
      name: "manualData",
      friendlyName: "Manual / Fallback Rating Data",
      helperText:
        "Used whenever a G2 product isn't selected, or if the live G2 lookup fails.",
      type: "object",
      localized: false,
      subFields: [
        {
          name: "ratingValue",
          type: "number",
          min: 0.1,
          max: 5,
          friendlyName: "Rating Value",
          localized: false,
        },
        {
          name: "reviewUrl",
          type: "url",
          friendlyName: "Review URL",
          localized: false,
        },
      ],
    },
    DLD_FIELD,
    DLT_FIELD,
    {
      name: "onG2Text",
      type: "string",
      friendlyName: "On G2 Text",
      helperText: "Text after the rating value.",
      defaultValue: {
        "@type": "@builder.io/core:LocalizedValue",
        Default: "on G2",
      },
      localized: true,
    },
    {
      name: "errorText",
      type: "string",
      friendlyName: "Error Message",
      helperText: "Shown only if no valid rating can be resolved at all",
      defaultValue: {
        "@type": "@builder.io/core:LocalizedValue",
        Default: "Read our reviews on G2",
      },
      localized: true,
    },
    {
      name: "errorFallbackUrl",
      type: "string",
      friendlyName: "Error Fallback URL",
      defaultValue:
        "https://www.g2.com/sellers/solarwinds-worldwide-llc#profiles",
      localized: false,
    },

    {
      ...DLD_FIELD,
      name: "errorDld",
      friendlyName: "Error link — Data link details",
      helperText: "Analytics value used only for the error / fallback link.",
    },
    {
      ...DLT_FIELD,
      name: "errorDlt",
      friendlyName: "Error link — Data link type",
      helperText: "Analytics value used only for the error / fallback link.",
    },
  ],
};
